import { MouseEvent, ReactNode } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Avatar, Chip, ChipProps } from '@mui/material'
import { colors } from '@global/constants'
import { User } from '@global/types'

type UserPartial = Pick<User, 'avatar_slug' | 'name'>

const FirstInitial = styled.span`
  font-size: 10px;
  color: #fff;
`

const blueBackground = css`
  background-color: ${colors.blue.main};
`

interface Props extends Omit<ChipProps, 'label'> {
  user: UserPartial
  label?: ReactNode
  // Per designs, this chip will have some click interactions, so accounting for that here
  onClick?: (e: MouseEvent) => void
}

const chipStyle = {
  cursor: 'pointer',
  '& .MuiChip-label': {
    display: 'flex',
    verticalAlign: 'middle',
    padding: '0 4px',
    color: '#888',
  },
  '& svg': {
    width: '.8em',
    height: '.8em',
  },
  '&:hover': {
    backgroundColor: 'rgba(0,0,0,0.15)',
  },
} as const

export const UserChip = ({ user, label, onClick, ...props }: Props) => {
  const name = user?.name || ''
  const slug = user?.avatar_slug
  const src = slug ? `/api/v1/avatar/${slug}` : undefined
  const firstInitial = name[0]

  return (
    <Chip
      avatar={
        <Avatar alt={name} src={src} css={blueBackground}>
          <FirstInitial>{firstInitial}</FirstInitial>
        </Avatar>
      }
      label={label || name}
      onClick={onClick}
      clickable={Boolean(onClick)}
      sx={label ? chipStyle : undefined}
      {...props}
    />
  )
}
